<template>
  <page-section
    id="cac-home__intro"
    class="cac-home__intro"
    banner>
    <div class="row">
      <div class="col-md-9">
        <slot name="left-wrapper"/>
      </div>
      <slot name="right-wrapper">
        <div class="col-md-8 offset-md-1">
          <personal-information
            :key="pageKey"
            :submit-button-text="wrapperFormButtonText"
          />
        </div>
      </slot>
    </div>
  </page-section>
</template>

<script>
import PersonalInformation from "CivicActionCenterComponents/shared/PersonalInformation.vue";
import PageSection from "CivicActionCenterComponents/shared/PageSection.vue";

export default {
  name: "BannerSection",
  components: {
    PersonalInformation,
    PageSection
  },
  props: {
    wrapperFormButtonText: {
      type: String,
      required: true
    },
    pageKey: {
      type: String,
      default: ""
    }
  }
};
</script>
